export const isInteger = (value: any) => {
  if (!value) {
    return undefined;
  }

  return new RegExp('^\\-?\\d*$').test(value) ? undefined : 'Must be number';
};
